import { render, staticRenderFns } from "./LabPortal.vue?vue&type=template&id=7cd61ffe&"
import script from "./LabPortal.vue?vue&type=script&lang=js&"
export * from "./LabPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports